const text=`
(\\__/)<br>
(>'.'<)<br>
(")_(")<br>`;
export default text;